const empty = () =>
    import( /* webpackChunkName: "empty" */ '../views/Empty.vue');

export default [{
    path: 'market',
    name: 'Market',
    component: empty,
    children: [{
            path: 'coupon',
            name: 'Coupon',
            component: empty,
            children: [{
                    path: 'manage',
                    name: 'CouponManage',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/coupon/CouponManage.vue'),
                    meta: {
                        title: '优惠券管理',
                        root: true
                    },
                },
                {
                    path: 'coupon-edit',
                    name: 'CouponEdit',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/coupon/CouponEdit.vue'),
                    meta: {
                        title: '新增/编辑优惠券'
                    },
                },
                {
                    path: 'coupon-detail',
                    name: 'CouponDetail',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/coupon/CouponDetail.vue'),
                    meta: {
                        title: '查看优惠券'
                    },
                },
                {
                    path: 'cecord',
                    name: 'CouponRecord',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/coupon/CouponRecord.vue'),
                    meta: {
                        title: '优惠券使用记录',
                        root: true
                    },
                },
                {
                    path: 'present',
                    name: 'CouponPresent',
                    component: () => import('../views/market/coupon/CouponPresent.vue'),
                    meta: {
                        title: '赠送优惠券',
                        root: true
                    },
                },
                {
                    path: 'CouponPresent-detail',
                    name: 'PresentDetail',
                    component: () => import('../views/market/coupon/PresentDetail.vue'),
                    meta: {
                        title: '赠送/查看详情'
                    },
                },
                {
                    path: 'CouponPresent-use',
                    name: 'CouponUse',
                    component: () => import('../views/market/coupon/CouponUse.vue'),
                    meta: {
                        title: '赠送/查看详情优惠券'
                    },
                },
            ],
        },
        {
            path: 'member',
            name: 'Member',
            component: empty,
            children: [{
                    path: 'manage',
                    name: 'MemberManage',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/member/MemberManage.vue'),
                    meta: {
                        title: '会员管理',
                        root: true
                    },
                },
                {
                    path: 'manage-edit',
                    name: 'MemberEdit',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/member/MemberEdit.vue'),
                    meta: {
                        title: '新建会员'
                    },
                },
                {
                    path: 'manage-import',
                    name: 'MemberImport',
                    component: () => import( /* webpackChunkName: "market" */ '../views/Imports.vue'),
                    meta: {
                        title: '批量导入'
                    },
                },
                {
                    path: 'manage-exports',
                    name: 'MemberExports',
                    component: () => import( /* webpackChunkName: "market" */ '../views/Exports'),
                    meta: {
                        title: '查看报表'
                    }
                },
                {
                    path: 'plan',
                    name: 'MemberPlan',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/member/MemberPlan.vue'),
                    meta: {
                        title: '会员计划',
                        root: true
                    },
                },
                {
                    path: 'plan-edit',
                    name: 'PlanEdit',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/member/PlanEdit.vue'),
                    meta: {
                        title: '新增/编辑'
                    },
                },
                {
                    path: 'course',
                    name: 'MemberCourse',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/member/MemberCourse'),
                    meta: {
                        title: '会员课程',
                        root: true
                    },
                },
            ],
        },
        {
            path: 'card',
            name: 'StudyCard',
            component: empty,
            meta: {
                bread: [{
                    title: '学习卡',
                    url: ''
                }],
            },
            children: [{
                    path: 'manage',
                    name: 'StudyCardManage',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/card/StudyCardManage'),
                    meta: {
                        title: '学习卡管理',
                        root: true
                    },
                },
                {
                    path: 'record',
                    name: 'StudyCardRecord',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/card/StudyCardRecord'),
                    meta: {
                        title: '学习卡兑换记录'
                    },
                },
                {
                    path: 'edit',
                    name: 'StudyCardEdit',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/card/StudyCardEdit'),
                    meta: {
                        title: '新增/查看学习卡'
                    },
                },
            ]
        },
        {
            path: 'group',
            name: 'GroupBooking',
            component: empty,
            meta: {
                bread: [{
                    title: '多人拼团',
                    url: ''
                }],
            },
            children: [{
                    path: 'manage',
                    name: 'GroupBookingManage',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/group/GroupBookingManage'),
                    meta: {
                        title: '多人拼团',
                        root: true
                    },
                },
                {
                    path: 'edit',
                    name: 'GroupBookingEdit',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/group/GroupBookingEdit'),
                    meta: {
                        title: '新建/编辑拼团'
                    },
                },
                {
                    path: 'detail',
                    name: 'GroupBookingDetail',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/group/GroupBookingDetail'),
                    meta: {
                        title: '拼团详情'
                    },
                },
            ]
        },
        {
            path: 'integral',
            name: 'Integral',
            component: empty,
            meta: {
                bread: [{
                    title: '积分管理',
                    url: ''
                }],
            },
            children: [{
                    path: 'store',
                    name: 'IntegralStore',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/integral/IntegralStore'),
                    meta: {
                        title: '积分商城',
                        root: true
                    },
                },
                {
                    path: 'goods/edit',
                    name: 'IntegralGoodsEdit',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/integral/IntegralGoodsEdit'),
                    meta: {
                        title: '新增/编辑商品'
                    },
                },
                {
                    path: 'exchange',
                    name: 'IntegralExchange',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/integral/IntegralExchange'),
                    meta: {
                        title: '兑换记录',
                        root: true
                    },
                },
                {
                    path: 'exchange/detail',
                    name: 'IntegralExchangeDetail',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/integral/IntegralExchangeDetail'),
                    meta: {
                        title: '订单详情'
                    },
                },
                {
                    path: 'manage',
                    name: 'IntegralManage',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/integral/IntegralManage'),
                    meta: {
                        title: '积分管理',
                        root: true
                    },
                },
                {
                    path: 'sort',
                    name: 'IntegralSort',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/integral/IntegralSort'),
                    meta: {
                        title: '积分排名',
                        root: true
                    }
                },
                {
                    path: 'record',
                    name: 'IntegralRecord',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/integral/IntegralRecord'),
                    meta: {
                        title: '积分记录'
                    },
                },
            ]
        },
        {
            path: 'sign',
            name: 'Sign',
            component: empty,
            children: [{
                    path: 'statistics',
                    name: 'SignStatistics',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/sign/SignStatistics'),
                    meta: {
                        title: '签到统计',
                        root: true
                    },
                },
                {
                    path: 'setting',
                    name: 'SignSetting',
                    component: () => import( /* webpackChunkName: "market" */ '../views/market/sign/SignSetting'),
                    meta: {
                        title: '签到设置',
                        root: true
                    },
                }
            ]
        },
    ],
}, ];
